import { handleActions } from 'redux-actions';
import { reset } from 'redux-form';
import { LOCATION_CHANGE, replace } from 'react-router-redux';

import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';
import values from  'lodash/values';
import forEach from  'lodash/forEach';
import find from 'lodash/find';
import pick from 'lodash/pick';
import _get from 'lodash/get';
import _map from 'lodash/map';

import { SubmissionError } from 'redux-form';
import http from '../shared/http';
import endpoints from '../../config/endpoints';
import intl from '../shared/intl';
import { createSelectOptionsFromSysEnumsForCountries } from '../shared/form-elements/select-countries';

import {
	createSelectOptionsFromSysEnums,
	createSelectValuesUseIntersection
} from '../shared/form-elements/select';
import checkPermissions from '../shared/check-permissions';

import { enum as adminPermissionsEnum } from '../../../../../enums/admin-permissions';
import createPermissions from './components/permissions';
import createProductivityForm from './components/monthly-productivity.index';

const permissions = createPermissions({
	namespaces: 'admins',
	stateNodeName: 'permissions'
});
const productivityForm = createProductivityForm();

// actions types
const FETCH_DATA_SUCCESS = 'admins/fetch-data-success';
const FETCH_DATA_ERROR = 'admins/fetch-data-error';

const FETCH_PAYOUT_SYSTEMS_SUCCESS = 'admins/fetch-payout-systems-success';
const FETCH_PAYOUT_SYSTEMS_ERROR = 'admins/fetch-payout-systems-error';

const SUBMIT_SUCCESS = 'admins/submit-success';
const SUBMIT_ERROR = 'admins/submit-error';

const REMOVE_SUCCESS = 'admins/remove-success';
const REMOVE_ERROR = 'admins/remove-error';

const UPLOAD_SUCCESS = 'admins/upload-success';
const UPLOAD_ERROR = 'admins/upload-error';
const PREPARATION_FILE_SUCCESS = 'admins/preparation-file-success';

const SORT_BY_COLUMN = 'admins/table-sort-by-column';
const SHOW_MORE_ROWS = 'admins/table-show-more-rows';

const TOGGLE_PROGRESS_BAR = 'admins/toggle-progress-bar';

const FETCH_COUNTRY_SUCCESS = 'admins/FETCH_COUNTRY_SUCCESS';
const FETCH_COUNTRY_ERROR = 'admins/FETCH_COUNTRY_ERROR';

const FETCH_SUGGEST_SUCCESS = 'admins/fetch-suggest-success';
const FETCH_SUGGEST_ERROR = 'admins/fetch-suggest-error';

const UPDATE_FROM_CSV_OK = 'admins/UPDATE_FROM_CSV_OK';
const UPDATE_FROM_CSV_NOT_OK = 'admins/UPDATE_FROM_CSV_NOT_OK';

const TAB_CHANGE = `admins/tab-change`;

const TOGGLE_AFFILIATE_DISTRIBUTION_POPUP = `admins/toggle-affiliate-distribution-popup`;
const DISTRIBUTE_AFFILIATES = `admins/DISTRIBUTE_AFFILIATES`;

const TOGGLE_CLONE_ADMIN_POPUP = `admins/TOGGLE_CLONE_ADMIN_POPUP`;
const CLONE_ADMIN = `admins/CLONE_ADMIN`;

const MAIN_FORM_PREPARATION_FILE = `admins/MAIN_FORM_PREPARATION_FILE`;

// permissions
export const allowedPermissions = {
	'view': 'admins_list',
	'create': 'admins_create',
	'edit': 'admins_create',
	'delete': 'admins_delete'
};

// initial state
const initialState = {
	data: null,
	payouts: [],
	showProgressBar: false,
	currentTab: 'main',
	showAffiliatedDistributionPopup: false,
	isClonePopupVisible: false,
	adminToRemove: null,
	permissions: permissions.initialState,
	file: null,
	table: {
		columns: {
			id: {
				index: 'id',
				title: 'Id',
				direction: 'desc'
			},
			email: {
				index: 'email',
				title: 'Email',
				direction: 'desc'
			},
			created_at: {
				index: 'created_at',
				title: 'Created',
				direction: 'desc'
			},
			updated_at: {
				index: 'updated_at',
				title: 'Updated',
				direction: 'desc'
			},
			is_manager: {
				index: 'is_manager',
				title: 'Incoming reg'
			},
			actions: {
				title: 'Actions'
			}
		},
		sortByColumn: {
			index: 'id',
			title: 'Id',
			direction: 'desc'
		},
		rowsNumber: 1000
	},
	form: {
		name: '',
		email: '',
		password: '',
		skype: '',
		telegram: '',
		manager_tg_id: null,
		role: null,
		config: null,
		languages: [],
		regions: null,
		permissions: [],
		is_manager: false,
		is_full_capacity: false,
		is_only_own_affiliates: false,
		is_restricted: false,
		substituting_ids: null,
		sub_ids: null,
		allowed_affiliate_ids: null,
		desired_real_approves_count: 0,
		timezone: null
	},
	fileToUpload: null,
	error: false,
	...productivityForm.initialState
};

// actions
export const actions = Object.assign(
	{
		fetchData: (props) => (dispatch, getState) => {
			(http({
				url: endpoints.ADMINS_LIST,
				method: 'get',
				actions: [
					FETCH_DATA_SUCCESS,
					FETCH_DATA_ERROR
				]
			}))(dispatch).then(action => {
				if (action.type === FETCH_DATA_SUCCESS && props.routeParams.id) {
					const getAdminInfo = selectors.getAdminFieldsById(getState());
					const adminInfo = getAdminInfo(props.routeParams.id);

					dispatch(actions.fetchPayoutSystems()).then(() => {
						dispatch(permissions.actions.permissionsControlSetInitialValues(
							adminInfo.permissionSelectOptions,
							adminInfo.permissionValues,
							adminInfo.subPermissionValues
						));
					});
				}
			});
		},
		preparationCsv: (file, nextAction) => dispatch => {
			const reader = new FileReader();
			const data = new FormData();

			data.append('table', file);

			reader.readAsDataURL(file);
			reader.onloadend = function () {
				nextAction && nextAction(reader.result);
				dispatch({
					type: MAIN_FORM_PREPARATION_FILE,
					payload: data
				});
			};
		},
		sendFile: (admin_id, e) => (dispatch, getState) => {
			e.preventDefault();
			const file = getState().admins.file;
			return http({
				url: `${endpoints.ADMIN_PROFILE}/${admin_id}/update-from-csv`,
				method: 'post',
				data: file,
				actions: [ UPDATE_FROM_CSV_OK, UPDATE_FROM_CSV_NOT_OK ]
			})(dispatch)
				.then(() => dispatch(productivityForm.actions.fetchMonthlyProductivity(admin_id)));
		},
		takePermissionFrom: ({clone_permission_admin_id}) => (dispatch, getState) => {
			const adminId = _get(clone_permission_admin_id, '0.value');
			if (!adminId) return;

			const getAdminInfo = selectors.getAdminFieldsById(getState());
			const adminInfo = getAdminInfo(adminId);

			dispatch(actions.fetchPayoutSystems()).then(() => {
				dispatch(permissions.actions.permissionsControlSetInitialValues(
					adminInfo.permissionSelectOptions,
					adminInfo.permissionValues,
					adminInfo.subPermissionValues
				));
			});
		},
		loadCountriesOptions: text => dispatch => {
			const request = http({
				url: `${endpoints.LOOKUPS.LOCATIONS}?query=${text}`,
				method: 'get',
				actions: [
					FETCH_COUNTRY_SUCCESS,
					FETCH_COUNTRY_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_COUNTRY_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnumsForCountries(action.payload.data)
					};
				}
			});
		},

		fetchPayoutSystems: () => dispatch => {
			const request = http({
				url: endpoints.PAYOUT_SYSTEMS.LIST,
				method: 'get',
				actions: [
					FETCH_PAYOUT_SYSTEMS_SUCCESS,
					FETCH_PAYOUT_SYSTEMS_ERROR
				]
			});

			return dispatch(request);
		},

		cloneAdmin: (formData) => dispatch => {
			const request = http({
				url: endpoints.ADMINS_CLONE,
				method: 'post',
				data: {
					...formData,
					cloneFromId: _get(formData, 'admin_ids.0.value')
				},
				actions: [ CLONE_ADMIN ]
			});

			return dispatch(request)
				.then(action => {
					if (action.type === CLONE_ADMIN) {
						dispatch(actions.toggleCloneAdminPopup());
						dispatch(actions.fetchData({ routeParams: {} }));
					}
				});
		},

		submitForm: (formData, adminId = null) => (dispatch, getState) => {
			const currentData = find(getState().admins.data, { id: parseInt(adminId) });
			const allowed_affiliate_ids = _map(formData.allowed_affiliate_ids, affId => affId.value);

			const request = http({
				url: !adminId ? endpoints.ADMINS_LIST : `${endpoints.ADMINS_LIST}/${adminId}`,
				method: !adminId ? 'post' : 'put',
				actions: [
					SUBMIT_SUCCESS,
					SUBMIT_ERROR
				],
				data: pick({
					...getState().admins.form,
					...formData,
					substituting_ids: formData.substituting_ids && formData.substituting_ids.length &&
					formData.substituting_ids.map(admin => admin.value) || null,
					sub_ids: formData.sub_ids && formData.sub_ids.length &&
						formData.sub_ids.map(admin => admin.value) || null,
					allowed_affiliate_ids: allowed_affiliate_ids.length ? allowed_affiliate_ids : null,
					role: formData.role && formData.role[0] && formData.role[0].value || null,
					languages: formData.languages && formData.languages.map(lang => lang.value) || [],
					regions: formData.regions && formData.regions.map(rn => rn.value),
					permissions: adminId ? currentData.permissions : [],
					config: formData.config ? JSON.parse(formData.config) : null,
					timezone: formData.timezone && formData.timezone[0] && formData.timezone[0].value || null
				}, Object.keys(getState().admins.form))
			});

			return request(dispatch)
				.then(action => {
					if (action.type === SUBMIT_SUCCESS) {
						const id = adminId || action.payload.data.id;
						const fileToUpload = getState().admins.fileToUpload;
						const redirectAction = adminId ? 'redirectToModuleIndex' : 'redirectToModuleEdit';

						if (fileToUpload) {
							actions.uploadFile(id, fileToUpload, dispatch).then(action => {
								if (action.type === UPLOAD_SUCCESS) {
									dispatch(actions[redirectAction](id));
								}
							});
						} else {
							dispatch(actions[redirectAction](id));
						}
					}

					if (action.type === SUBMIT_ERROR && action.payload.response.status === 400) {
						const validationsErrors = {};
						const responseErrors = action.payload.response.data;

						forEach(responseErrors, value => {
							const key = value.dataPath.slice(1);
							validationsErrors[key] = value.message;
						});

						throw new SubmissionError(validationsErrors);
					}
				});
		},

		uploadFile: (adminId, fileToUpload, dispatch) => {
			const request = http({
				url: `${endpoints.ADMINS_LIST}/${adminId}/avatar`,
				method: 'put',
				actions: [
					UPLOAD_SUCCESS,
					UPLOAD_ERROR
				],
				data: fileToUpload
			});

			dispatch(actions.toggleProgressBar());

			return request(dispatch);
		},

		preparationFile: (file, nextAction) => dispatch => {
			const reader = new FileReader();
			const data = new FormData();

			data.append('avatar', file);

			reader.readAsDataURL(file);
			reader.onloadend = function () {
				nextAction(reader.result);
				dispatch({
					type: PREPARATION_FILE_SUCCESS,
					payload: data
				});
			};
		},

		remove: id => dispatch => {
			const request = http({
				url: `${endpoints.ADMINS_LIST}/${id}`,
				method: 'delete',
				actions: [
					REMOVE_SUCCESS,
					REMOVE_ERROR
				]
			});

			dispatch(actions.toggleProgressBar());

			request(dispatch);
		},
		distributeAffiliates: formData => (dispatch, getState) => {
			const distributeToIds = (formData.admin_ids || []).map(adm => adm.value);
			const distributeFromId = _get(formData, 'source_admin_id.0.value', null);

			dispatch(actions.toggleProgressBar());

			const request = http({
				url: endpoints.ADMIN_DISTRIBUTE_AFFILIATES.replace('{id}', distributeFromId),
				method: 'put',
				data: { admin_ids: distributeToIds },
				actions: [ DISTRIBUTE_AFFILIATES ]
			});

			return request(dispatch)
				.then(action => {
					dispatch(actions.toggleProgressBar());
					dispatch(actions.toggleAffiliateDistributionPopup());
				});
		},

		distributeAndRemove: formData => (dispatch, getState) => {
			const distributeToIds = (formData.admin_ids || []).map(adm => adm.value);
			const distributeFromId = _get(formData, 'source_admin_id.0.value', null);

			dispatch(actions.toggleProgressBar());

			const request = http({
				url: endpoints.ADMIN_DISTRIBUTE_AFFILIATES.replace('{id}', distributeFromId),
				method: 'put',
				data: { admin_ids: distributeToIds },
				actions: [ DISTRIBUTE_AFFILIATES ]
			});

			return request(dispatch)
				.then(action => {
					dispatch(actions.toggleProgressBar());
					dispatch(actions.toggleAffiliateDistributionPopup());
					if (action.type === DISTRIBUTE_AFFILIATES) {
						return dispatch(actions.remove(distributeFromId));
					}
				});
		},
		toggleAffiliateDistributionPopup:  () => dispatch => {
			dispatch(reset('affiliateDistributionForm'));
			return dispatch({ type: TOGGLE_AFFILIATE_DISTRIBUTION_POPUP });
		},
		toggleCloneAdminPopup:  () => dispatch => {
			dispatch(reset('cloneAdminForm'));
			return dispatch({
				type: TOGGLE_CLONE_ADMIN_POPUP
			});
		},

		sortByColumn: columnIndex => ({
			type: SORT_BY_COLUMN,
			payload: columnIndex
		}),

		showMoreRows: () => ({
			type: SHOW_MORE_ROWS
		}),

		redirectToModuleIndex: () => dispatch => {
			// @todo Adhock for redux-form submit functionality.
			setTimeout(() => dispatch(replace('admins/')), 100);
		},

		redirectToModuleEdit: (adminId) => dispatch => {
			setTimeout(() => dispatch(replace(`admins/edit/${adminId}`)), 100);
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		}),

		loadAdminsLookup: (text, isShowAll = false) => dispatch => {
			const request = http({
				url: `${endpoints.LOOKUPS.ADMINS}?query=${text}&show_all=${isShowAll || ''}`,
				method: 'get',
				actions: [
					FETCH_SUGGEST_SUCCESS,
					FETCH_SUGGEST_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		},

		loadRegionsLookup: (text, isShowAll = false) => dispatch => {
			const request = http({
				url: `${endpoints.LOOKUPS.REGIONS}`,
				method: 'get',
				actions: [
					FETCH_SUGGEST_SUCCESS,
					FETCH_SUGGEST_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
							.filter(item => item.label)
					};
				}
			});
		},
		updatePossibleRegions: (admin_id, index) => dispatch => {
			const request = http({
				url: `${endpoints.LOOKUPS.REGIONS}?admin_id=${admin_id}`,
				method: 'get',
				actions: [
					FETCH_SUGGEST_SUCCESS,
					FETCH_SUGGEST_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		},

		loadAffiliatesLookup: text => dispatch => {
			const request = http({
				url: `${endpoints.LOOKUPS.AFFILIATES}?query=${text}`,
				method: 'get',
				actions: [
					FETCH_SUGGEST_SUCCESS,
					FETCH_SUGGEST_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		},

		changeTab: tabName => ({
			type: TAB_CHANGE,
			payload: tabName
		}),
		loadAllAdminsLookup: text => dispatch => {
			return dispatch(actions.loadAdminsLookup(text, true));
		},

		timezonesLookup: text => (dispatch, getState) => {
			const timezones = (getState()).root.lists.timezones;
			const search = timezones.filter(item => text ? item.text.toLowerCase().indexOf(text.toLowerCase()) !== -1 : item);
			const options = createSelectOptionsFromSysEnums(search.slice(0, 4));
			return Promise.resolve({ options });
		}
	},
	permissions.actions,
	productivityForm.actions
);

// reducers
const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			if (
				action.payload.pathname.indexOf('admins') !== -1 &&
				action.payload.pathname.indexOf('admins/create') === -1
			) {
				return initialState;
			}

			return state;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return { ...state, data: action.payload.data, showProgressBar: false, error: false };
		},
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[FETCH_PAYOUT_SYSTEMS_SUCCESS]: (state, action) => {
			return { ...state, payouts: action.payload.data, showProgressBar: false, error: false };
		},
		[SORT_BY_COLUMN]: (state, action) => {
			const { sortByColumn, columns }  = state.table;
			const columnIndex = action.payload;
			const direction = sortByColumn['index'] == columnIndex ?
				sortByColumn.direction === 'desc' ? 'asc' : 'desc' :
				columns[columnIndex].direction;

			return {
				...state,
				table: {
					...state.table,
					sortByColumn: {
						...columns[columnIndex],
						direction
					}
				}
			};
		},
		[SHOW_MORE_ROWS]: state => ({
			...state,
			table: {
				...state.table,
				rowsNumber: state.table.rowsNumber += initialState.table.rowsNumber
			}
		}),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[TOGGLE_AFFILIATE_DISTRIBUTION_POPUP]: (state, action) => ({
			...state,
			showAffiliatedDistributionPopup: !state.showAffiliatedDistributionPopup
		}),
		[TOGGLE_CLONE_ADMIN_POPUP]: (state, action) => ({
			...state,
			isClonePopupVisible: !state.isClonePopupVisible
		}),
		[REMOVE_SUCCESS]: state => ({...state, data: null}),
		[MAIN_FORM_PREPARATION_FILE]: (state, action) => ({...state, file: action.payload}),
		[REMOVE_ERROR]: state => ({...state, error: true}),
		[PREPARATION_FILE_SUCCESS]: (state, action) => ({...state, fileToUpload: action.payload}),
		[UPLOAD_SUCCESS]: state => ({...state, fileToUpload: null}),
		[SUBMIT_ERROR]: (state, action) => {
			const { response: {status = null, data = null} } = action.payload;
			if (status === 400 && !!data) return state;
			return { ...state, error: true };
		},
		[TAB_CHANGE]: (state, action) => ({ ...state, currentTab: action.payload })
	},
	permissions.reducers,
	productivityForm.reducers
);
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.admins.data,
	getTable: state => {
		const { table, data } = state.admins;
		const rows = state.admins.data ? sortColumns(data, table.sortByColumn) : [];

		return {
			headers: values(table.columns),
			rows: rows.slice(0, table.rowsNumber),
			sortedColumn: table.sortByColumn,
			rowsNumber: table.rowsNumber,
			totalRows: rows.length
		};
	},
	getLangSelectOptions: state => createSelectOptionsFromSysEnums(state.root.lists.languages),
	getTimezoneOptions: state => createSelectOptionsFromSysEnums(state.root.lists.timezones),
	getAdminRoles: state => createSelectOptionsFromSysEnums(state.root.lists['admin-roles']),
	getPermissionsSelectOptions: state => {
		let currentAdminPermissions = state.root.data && state.root.data.permissions;
		if (
			currentAdminPermissions &&
			currentAdminPermissions.indexOf(adminPermissionsEnum.adminsSetGlobalPermissions) !== -1
		) {
			return createSelectOptionsFromSysEnums(state.root.lists['admin-permissions']);
		} else {
			return createSelectOptionsFromSysEnums(state.root.lists['admin-permissions'].filter(perm => {
				return currentAdminPermissions.indexOf(perm.id) !== -1;
			}));
		}
	},
	getHiddenPermissions: state => {
		let currentAdminPermissions = state.root.data && state.root.data.permissions;
		if (
			currentAdminPermissions &&
			currentAdminPermissions.indexOf(adminPermissionsEnum.adminsSetGlobalPermissions) !== -1
		) {
			return null;
		} else {
			return createSelectOptionsFromSysEnums(state.root.lists['admin-permissions'].filter(perm => {
				return currentAdminPermissions.indexOf(perm.id) === -1;
			}));
		}
	},
	getIntl: state => intl(state),
	getProgressBar: state => state.admins.showProgressBar,
	getAdminFieldsById: state => adminId => {
		const current = find(state.admins.data, { id: parseInt(adminId) });
		const timezones = createSelectOptionsFromSysEnums(state.root.lists.timezones);
		const allowed_affiliate_ids = _map(current.allowed_affiliate_ids, affId => ({ value: affId, label: affId }));

		return {
			...state.admins.form,
			...current,
			languages: createSelectValuesUseIntersection(
				selectors.getLangSelectOptions(state),
				current.languages
			),
			regions: current.regions && current.regions.map(rr => ({ value: rr, label: rr })),
			role: createSelectValuesUseIntersection(selectors.getAdminRoles(state), [current.role]),
			permissionSelectOptions: createSelectValuesUseIntersection(
				selectors.getPermissionsSelectOptions(state),
				getPermissionsWithoutSubs(current.permissions)
			),
			permissionValues: getPermissionsWithoutSubs(current.permissions),
			subPermissionValues: getSubPermissionsValue(current.permissions),
			allowed_affiliate_ids: allowed_affiliate_ids.length ? allowed_affiliate_ids : null,
			substituting_ids: current.substituting_admins && current.substituting_admins.length ?
				current.substituting_admins.map(admin => ({value: admin.id, label: admin.email})) : null,
			sub_ids: current.sub_ids && current.sub_ids.length ?
				current.sub_ids.map(admin => ({value: admin.id, label: admin.email})) : null,
			timezone: createSelectValuesUseIntersection(timezones, [current.timezone])
		};
	},
	getCurrentTab: state => state.admins.currentTab,
	getShowAffiliatedDistributionPopup: state => state.admins.showAffiliatedDistributionPopup,
	getIsClonePopupVisible: state => state.admins.isClonePopupVisible,
	getAdminToRemove: state => state.admins.adminToRemove,
	getManagers: state => {
		const admins = state.admins.data || [];

		return admins
			.filter(adm => adm.is_manager)
			.map(adm => ({ label: adm.email, value: adm.id }));
	},
	getAdmins: state => {
		const admins = state.admins.data || [];

		return admins.map(adm => ({ label: adm.email, value: adm.id }));
	},
	getPermissionsList: state => permissions.selectors.getPermissionsList(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.admins.error,
	...productivityForm.selectors
};

// functions
const sortColumns = (rows, sortedColumn) => {
	if (!rows) return null;
	return orderBy(rows, row => {
		const value = row[sortedColumn.index];
		switch (sortedColumn.index) {
			case 'id':
			case 'email':
			case 'created_at':
			case 'updated_at':
				return value;
			default:
				return value;
		}
	}, sortedColumn.direction);
};

const getPermissionsWithoutSubs = currentPermissions => {
	return currentPermissions.map(permission => {
		const subpermissionsMatch = permission.match(/(.+):\[(.+)\]/);
		if (!subpermissionsMatch || subpermissionsMatch.length !== 3) {
			return permission;
		}

		return subpermissionsMatch[1];
	});
};

const getSubPermissionsValue = currentPermissions => {
	return currentPermissions
		.filter(permission => {
			const subpermissionsMatch = permission.match(/(.+):\[(.+)\]/);
			return (subpermissionsMatch && subpermissionsMatch.length === 3);
		})
		.map(permission => {
			const subpermissionsMatch = permission.match(/(.+):\[(.+)\]/);
			return {
				relationRule: subpermissionsMatch[1],
				value: subpermissionsMatch[2]
			};
		});
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/index.js